import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { WebsiteBackupTarget } from '../../../../shared/models/backups.models';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JsonPipe } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';

@Component({
  selector: 'app-backup-details-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    FontAwesomeModule,
    ClipboardModule,
    JsonPipe,
  ],
  templateUrl: './backup-details-dialog.component.html',
  styleUrl: './backup-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupDetailsDialogComponent {
  private snackbar = inject(MatSnackBar);

  readonly dialogRef = inject(MatDialogRef<BackupDetailsDialogComponent>);

  readonly data = inject<
    DialogData & {
      backupId: number;
      websiteBackupId: number;
      backupTargets: WebsiteBackupTarget[];
      config: object;
    }
  >(MAT_DIALOG_DATA);

  get targets(): { title: string; items: string[] }[] {
    return [
      {
        title: 'Directory:',
        items: this.data.backupTargets
          .filter((t) => t.snapshotTargetType === 'directory')
          .map((t) => t.snapshotTarget),
      },
      {
        title: 'MySQL Database(s):',
        items: this.data.backupTargets
          .filter((t) => t.snapshotTargetType === 'database')
          .map((t) => t.snapshotTarget),
      },
      {
        title: 'Mailboxes:',
        items: this.data.backupTargets
          .filter((t) => t.snapshotTargetType === 'mailbox')
          .map((t) => t.snapshotTarget),
      },
    ];
  }

  onCopied(success: boolean) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: 'Copied to clipboard!',
        },
      });
    }
  }

  submit(): void {
    this.dialogRef.close({ download: true });
  }

  close(): void {
    this.dialogRef.close();
  }
}
